var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-partner"},[_c('img',{staticClass:"content",attrs:{"src":require(("@/assets/partner" + (_vm.color&&'_'+_vm.color) + "@2x.png")),"alt":"合作伙伴"}})])}
var staticRenderFns = []

export { render, staticRenderFns }